import { BackendInputWithLabel } from "@/app/components/backend";
import { ErrorMessage } from "./error-message";
import type { ChangeEvent, FocusEvent, InputHTMLAttributes } from "react";

export default function PasswordInput({
  passwordError,
  confirmPasswordError,
  showPasswordToggle = false,
  confirmPassword = false,
  value,
  required,
  onChange,
  onFocus,
  onBlur,
  className,
  autoComplete,
}: {
  passwordError: string;
  confirmPasswordError?: string;
  showPasswordToggle?: boolean;
  confirmPassword?: boolean;
  value?: string;
  required?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  className?: string;
  autoComplete?: InputHTMLAttributes<HTMLInputElement>["autoComplete"];
}) {
  // Bestimme die Prop-Werte basierend auf confirmPassword
  const name = confirmPassword ? "confirm_password" : "password";
  const label = confirmPassword ? "Passwort bestätigen" : "Passwort";
  const id = confirmPassword ? "confirm_password" : "password";
  const passwordAutoComplete =
    autoComplete ?? (confirmPassword ? "new-password" : "new-password");

  // Bestimme die Fehlermeldung basierend darauf, ob es ein Bestätigungspasswort ist
  const errorMessage = confirmPassword
    ? confirmPasswordError || ""
    : passwordError || "";

  return (
    <div>
      <BackendInputWithLabel
        name={name}
        autoComplete={passwordAutoComplete}
        label={label}
        aria-label={label}
        type="password"
        id={id}
        required={required}
        showPasswordToggle={showPasswordToggle}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        className={className}
      />
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
}
